<template>
  <span>
    <div v-loading="loading">
      <div v-if="invalidWebform">
        <span v-html="responseHtml"></span>
      </div>
      <div v-if="!invalidWebform" :data-active-page="pageIndex">
        <div
          class="category"
          v-for="(categories, categorieKey) in categories"
          :data-category="categorieKey"
          :key="'cat' + categorieKey"
          :class="categories.cssClasses"
        >
          <el-progress
            v-if="webform.webformProgressDisplay == 1"
            :percentage="progressBar"
            :status="progressBar === 100 ? 'success' : undefined"
          ></el-progress>
          <div
            v-for="(pages, $pageKey) in categories.pages"
            :data-page="$pageKey"
            :key="'page' + $pageKey"
            :class="pages.cssClasses"
          >
            <div v-show="$pageKey === pageIndex">
              <el-form
                ref="pageForm"
                :model="storeData.formData"
                :rules="validations"
                style="padding: 0 10px;"
              >
                <!--------------- Responsive Layout Mobile --------------->
                <span
                  v-if="getWebformWidth() < 760"
                >
                  <div class="divider-line hidden-sm-and-up">
                    <div class="divider-left">
                      <span class="page-title">{{ pages.name[languageId] }}</span>
                      <span style="margin-left: 0.5rem;">&nbsp;</span>
                      <span class="page-index">{{ pageIndex + 1 }} / {{ pageIndexLast }}</span>
                    </div>
                  </div>

                  <el-row
                    v-for="(rows, row1KeyResp) in pages.rows"
                    :key="$pageKey + 'row1' + row1KeyResp"
                    class="row hidden-sm-and-up"
                    justify="start"
                    align="middle"
                    :gutter="20"
                    :class="rows.cssClasses"
                >
                    <span
                      v-for="(col1, col1KeyResp) in rows.cols"
                      :key="'col1' + col1KeyResp"
                      :class="col1.cssClasses"
                    >
                      <span
                        v-for="(row1, row2KeyResp) in col1.rows"
                        :key="'row2' + row2KeyResp"
                      >
                        <el-col
                          v-for="(col2, col2KeyResp) in row1.cols"
                          :key="'col2' + col2KeyResp"
                        >
                          <div
                            v-for="(field, fieldKeyResp) in col2"
                            :key="'fld' + fieldKeyResp"
                            class="field"
                            :class="field.cssClasses"
                          >
                            <!---------- Component: Texteingabefeld | Type: TextInput ---------->
                            <span v-if="field.type === 'TextInput'">
                              <span v-show="!field.hideField">
                                <el-form-item
                                  :label="
                                    field.hideLabel
                                      ? false
                                      : field.name[languageId]
                                  "
                                  label-position="top"
                                  :required="field.mandatory"
                                  :prop="field.id.toString()"
                                >
                                  <el-tooltip
                                    :disabled="!field.text[languageId] != ''"
                                    effect="dark"
                                    :content="field.text[languageId]"
                                    placement="bottom-start"
                                    :open-delay="800"
                                  >
                                    <el-input
                                      v-model="storeData.formData[field.id]"
                                      clearable
                                      @change="action(field)"
                                    ></el-input>
                                  </el-tooltip>
                                </el-form-item>
                              </span>
                            </span>
                            <!---------- Component: Datumsfeld | Type: DateCallout ---------->
                            <span v-else-if="field.type === 'DateCallout'">
                              <span v-show="!field.hideField">
                                <el-form-item
                                  :label="
                                    field.hideLabel
                                      ? false
                                      : field.name[languageId]
                                  "
                                  label-position="top"
                                  class="date-picker-label"
                                  :required="field.mandatory"
                                  :prop="field.id.toString()"
                                >
                                  <el-tooltip
                                    :disabled="!field.text[languageId] != ''"
                                    effect="dark"
                                    :content="field.text[languageId]"
                                    placement="top"
                                    :open-delay="800"
                                  >
                                    <el-date-picker
                                      v-model="storeData.formData[field.id]"
                                      format="dd.MM.yyyy"
                                      @change="action(field)"
                                    >
                                    </el-date-picker>
                                  </el-tooltip>
                                </el-form-item>
                              </span>
                            </span>
                          
                            <!---------- Component: Textarea | Type: TextArea ----------->
                            <span
                              v-else-if="
                                (field.type === 'TextArea') & !field.hideField
                              "
                            >
                              <el-form-item
                                :label="
                                  field.hideLabel ? false : field.name[languageId]
                                "
                                label-position="top"
                                :required="field.mandatory"
                                :prop="field.id.toString()"
                              >
                                <el-tooltip
                                  :disabled="!field.text[languageId] != ''"
                                  effect="dark"
                                  :content="field.text[languageId]"
                                  placement="bottom-start"
                                  :open-delay="800"
                                >
                                  <el-input
                                    type="textarea"
                                    :rows="3"
                                    placeholder=""
                                    v-model="storeData.formData[field.id]"
                                    @change="action(field)"
                                  >
                                  </el-input>
                                </el-tooltip>
                              </el-form-item>
                            </span>
                          
                            <!---------- Component: Checkbox Group | Type: CheckboxGroup -->
                            <span
                              v-else-if="
                                (field.type === 'CheckboxGroup') &
                                !field.hideField
                              "
                            >
                              <el-form-item
                                :label="
                                  field.hideLabel ? false : field.name[languageId]
                                "
                                labelPosition="top"
                                :prop="field.id.toString()"
                                class="checkbox-label"
                              >
                                <el-checkbox-group
                                  v-model="storeData.formData[field.id]"
                                >
                                  <span
                                    v-for="(
                                      optionCheckboxResp, optionKeyCheckboxResp
                                    ) in field.options"
                                    :key="'opti' + optionKeyCheckboxResp"
                                  >
                                    <el-col class="checkbox-col">
                                      <el-checkbox
                                        :label="optionCheckboxResp.id.toString()"
                                        @change="
                                          action(
                                            field,
                                            optionCheckboxResp.id
                                          )
                                        "
                                      >
                                        <span
                                          v-html="
                                            optionCheckboxResp.name[languageId]
                                          "
                                        ></span>
                                      </el-checkbox>
                                    </el-col>
                                  </span>
                                </el-checkbox-group>
                              </el-form-item>
                            </span>
                          
                            <!---------- Component: Radiobox Group | Type: RadioGroup ---------->
                            <span
                              v-else-if="
                                (field.type === 'RadioGroup') & !field.hideField
                              "
                            >
                              <el-form-item
                                :label="
                                  field.hideLabel ? false : field.name[languageId]
                                "
                                label-position="top"
                                :required="field.mandatory"
                                :prop="field.id.toString()"
                                class="radio-label"
                              >
                                <el-radio-group
                                  v-model="storeData.formData[field.id]"
                                >
                                  <span
                                    v-for="(
                                      optionRadioResp, optionKeyRadioResp
                                    ) in field.options"
                                    :key="'opti' + optionKeyRadioResp"
                                  >
                                    <el-col>
                                      <span v-if="!field.hideField">
                                        <el-tooltip
                                          :disabled="
                                            !field.text[languageId] != ''
                                          "
                                          effect="dark"
                                          :content="field.text[languageId]"
                                          placement="right"
                                          :open-delay="800"
                                        >
                                          <el-radio
                                            v-model="
                                              storeData.formData[
                                                optionRadioResp.id
                                              ]
                                            "
                                            :label="
                                              optionRadioResp.name[languageId]
                                            "
                                            class="radio"
                                            :disabled="
                                              !optionRadioResp.slotsAvailable
                                            "
                                            @change="action(field)"
                                          >
                                          </el-radio>
                                        </el-tooltip>
                                      </span>
                                    </el-col>
                                  </span>
                                </el-radio-group>
                              </el-form-item>
                            </span>
                          
                            <!---------- Component: Hinweis | Type: Text ---------->
                            <span
                              v-else-if="
                                (field.type === 'Text') & !field.hideField
                              "
                            >
                              <span>
                                <p v-if="!field.hideLabel" class="text-label">
                                  <span v-html="field.name[languageId]"> </span>
                                </p>
                                <span
                                  class="text-content"
                                  v-html="field.text[languageId]"
                                ></span>
                              </span>
                              <!--/el-form-item-->
                            </span>
                          
                            <!---------- Component: Dropdown | Type: Dropdown ---------->
                            <span
                              v-else-if="
                                (field.type === 'Dropdown') & !field.hideField
                              "
                            >
                              <el-form-item
                                :label="
                                  field.hideLabel ? false : field.name[languageId]
                                "
                                label-position="top"
                                :required="field.mandatory"
                                class="dropwdown-label"
                                :prop="field.id.toString()"
                              >
                                <el-tooltip
                                  :disabled="!field.text[languageId] != ''"
                                  effect="dark"
                                  :content="field.text[languageId]"
                                  placement="top"
                                  :open-delay="800"
                                >
                                  <el-select
                                    v-model="storeData.formData[field.id]"
                                    filterable
                                    clearable
                                    class="full-width"
                                    @change="action(field)"
                                    :value="storeData.formData[field.id]"
                                  >
                                    <el-option
                                      v-for="(
                                        optionDropdownResp, optionKeyDropdownResp
                                      ) in field.options"
                                      :key="'opti' + optionKeyDropdownResp"
                                      :label="optionDropdownResp.name[languageId]"
                                      :value="optionDropdownResp.id"
                                      :disabled="
                                        !optionDropdownResp.slotsAvailable
                                      "
                                    >
                                    </el-option>
                                  </el-select>
                                </el-tooltip>
                              </el-form-item>
                            </span>
                          
                            <!---------- Component: Toggle Switch | Type: ToggleSwitch ---------->
                            <span
                              v-else-if="
                                (field.type === 'ToggleSwitch') & !field.hideField
                              "
                            >
                              <el-form-item
                                :label="
                                  field.hideLabel ? false : field.name[languageId]
                                "
                                label-position="top"
                                :required="field.mandatory"
                                :prop="field.id.toString()"
                              >
                                <el-tooltip
                                  :disabled="!field.text[languageId] != ''"
                                  effect="dark"
                                  :content="field.text[languageId]"
                                  placement="bottom-start"
                                  :open-delay="800"
                                >
                                  <el-switch
                                    v-model="storeData.formData[field.id]"
                                    @change="action(field)"
                                  >
                                  </el-switch>
                                </el-tooltip>
                              </el-form-item>
                            </span>
                          
                            <!---------- Component: AssetList | Type: AssetList ---------->
                            <span
                              v-else-if="
                                (field.type === 'AssetList') & !field.hideField
                              "
                            >
                              <el-form-item
                                :label="
                                  field.hideLabel ? false : field.name[languageId]
                                "
                                label-position="top"
                                :required="field.mandatory"
                                class="dropwdown-label"
                                :prop="field.id.toString()"
                              >
                                <el-select
                                  v-model="storeData.formData[field.id]"
                                  filterable
                                  clearable
                                  multiple
                                  collapse-tags
                                >
                                  <el-option
                                    v-for="(
                                      optionAssetResp, optionKeyAssetResp
                                    ) in field.options"
                                    :key="'opti' + optionKeyAssetResp"
                                    :label="optionAssetResp.name.intern"
                                    v-model="optionAssetResp.id"
                                  >
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </span>
                          </div>
                        </el-col>
                      </span>
                    </span>
                  </el-row>
                </span>
                <!--------------- Responsive Layout Desktop --------------->
                <span
                  v-else
                >
                  <div class="divider-line hidden-xs-only">
                    <div class="divider-left">
                      <span class="page-title">{{ pages.name[languageId] }}</span>
                      <span style="margin-left: 0.5rem;">&nbsp;</span>
                      <span class="page-index">{{ pageIndex + 1 }} / {{ pageIndexLast }}</span>
                    </div>
                    <div class="divider-right">
                      <el-button
                        icon="el-icon-arrow-left"
                        circle
                        v-bind:disabled="pageIndex === 0"
                        v-on:click="
                          pageIndex -= 1;
                          calculateProgressbar(pageIndex, pageIndexLast - 1);
                        "
                        v-if="
                          webform.webformPageNavigation == 1 ||
                          webform.webformPageNavigation == 3
                        "
                      ></el-button>
                      <el-button
                        icon="el-icon-arrow-right"
                        circle
                        v-on:click="validatePageForm(pageIndex, pageIndexLast)"
                        v-bind:disabled="pageIndex === pageIndexLast - 1"
                        v-if="
                          webform.webformPageNavigation == 1 ||
                          webform.webformPageNavigation == 3
                        "
                      ></el-button>
                    </div>
                  </div>

                  <el-row
                    v-for="(rows, row1Key) in pages.rows"
                    :key="'row1' + row1Key"
                    class="row hidden-xs-only"
                    justify="start"
                    align="middle"
                    :gutter="20"
                    :class="rows.cssClasses"
                  >
                    <el-col
                      v-for="(cols, col1Key) in rows.cols"
                      :key="'col1' + col1Key"
                      class="col"
                      :span="cols.size * 2"
                      :class="cols.cssClasses"
                    >
                      <el-row
                        v-for="(rows, row2Key) in cols.rows"
                        :key="'row2' + row2Key"
                        class="row"
                        :gutter="20"
                      >
                        <el-col
                          v-for="(cols, col2Key) in rows.cols"
                          :key="'col2' + col2Key"
                          class="col"
                          :span="cols.size * 2"
                        >
                          <div
                            v-for="(field, fieldKey) in cols"
                            :key="'fiel' + fieldKey"
                            class="field"
                            :class="field.cssClasses"
                          >
                            <!---------- Responsive Component: Texteingabefeld | Type: TextInput ---------->
                            <span v-if="field.type === 'TextInput'">
                              <span v-show="!field.hideField">
                                <el-form-item
                                  :label="
                                    field.hideLabel
                                      ? false
                                      : field.name[languageId]
                                  "
                                  label-position="top"
                                  :required="field.mandatory"
                                  :prop="field.id.toString()"
                                >
                                  <el-tooltip
                                    :disabled="!field.text[languageId] != ''"
                                    effect="dark"
                                    :content="field.text[languageId]"
                                    placement="bottom-start"
                                    :open-delay="800"
                                  >
                                    <el-input
                                      v-model="storeData.formData[field.id]"
                                      clearable
                                      @change="action(field)"
                                    ></el-input>
                                  </el-tooltip>
                                </el-form-item>
                              </span>
                            </span>
                            <!---------- Responsive Component: Datumsfeld | Type: DateCallout ---------->
                            <span v-else-if="field.type === 'DateCallout'">
                              <span v-show="!field.hideField">
                                <el-form-item
                                  :label="
                                    field.hideLabel
                                      ? false
                                      : field.name[languageId]
                                  "
                                  label-position="top"
                                  class="date-picker-label"
                                  :required="field.mandatory"
                                  :prop="field.id.toString()"
                                >
                                  <el-tooltip
                                    :disabled="!field.text[languageId] != ''"
                                    effect="dark"
                                    :content="field.text[languageId]"
                                    placement="top"
                                    :open-delay="800"
                                  >
                                    <el-date-picker
                                      v-model="storeData.formData[field.id]"
                                      format="dd.MM.yyyy"
                                      @change="action(field)"
                                    >
                                    </el-date-picker>
                                  </el-tooltip>
                                </el-form-item>
                              </span>
                            </span>

                            <!---------- Responsive Component: Textarea | Type: TextArea ----------->
                            <span
                              v-else-if="
                                (field.type === 'TextArea') & !field.hideField
                              "
                            >
                              <el-form-item
                                :label="
                                  field.hideLabel ? false : field.name[languageId]
                                "
                                label-position="top"
                                :required="field.mandatory"
                                :prop="field.id.toString()"
                              >
                                <el-tooltip
                                  :disabled="!field.text[languageId] != ''"
                                  effect="dark"
                                  :content="field.text[languageId]"
                                  placement="bottom-start"
                                  :open-delay="800"
                                >
                                  <el-input
                                    type="textarea"
                                    :rows="3"
                                    placeholder=""
                                    v-model="storeData.formData[field.id]"
                                    @change="action(field)"
                                  >
                                  </el-input>
                                </el-tooltip>
                              </el-form-item>
                            </span>

                            <!---------- Responsive Component: Checkbox Group | Type: CheckboxGroup -->
                            <span
                              v-else-if="
                                (field.type === 'CheckboxGroup') &
                                !field.hideField
                              "
                            >
                              <el-form-item
                                :label="
                                  field.hideLabel ? false : field.name[languageId]
                                "
                                labelPosition="top"
                                :prop="field.id.toString()"
                                class="checkbox-label"
                              >
                                <el-checkbox-group
                                  v-model="storeData.formData[field.id]"
                                >
                                  <span
                                    v-for="(
                                      optionCheckbox, optionKeyCheckbox
                                    ) in field.options"
                                    :key="'opti' + optionKeyCheckbox"
                                  >
                                    <el-col class="checkbox-col">
                                      <el-checkbox
                                        :label="optionCheckbox.id.toString()"
                                        @change="
                                          action(
                                            field,
                                            optionCheckbox.id
                                          )
                                        "
                                        :disabled="!optionCheckbox.slotsAvailable"
                                      >
                                        <span
                                          v-html="optionCheckbox.name[languageId]"
                                        ></span>
                                      </el-checkbox>
                                    </el-col>
                                  </span>
                                </el-checkbox-group>
                              </el-form-item>
                            </span>

                            <!---------- Responsive Component: Radiobox Group | Type: RadioGroup ---------->
                            <span
                              v-else-if="
                                (field.type === 'RadioGroup') & !field.hideField
                              "
                            >
                              <el-form-item
                                :label="
                                  field.hideLabel ? false : field.name[languageId]
                                "
                                label-position="top"
                                :required="field.mandatory"
                                :prop="field.id.toString()"
                                class="radio-label"
                              >
                                <el-radio-group
                                  v-model="storeData.formData[field.id]"
                                >
                                  <span
                                    v-for="(
                                      optionRadio, optionKeyRadio
                                    ) in field.options"
                                    :key="'opti' + optionKeyRadio"
                                  >
                                    <el-col>
                                      <span v-if="!field.hideField">
                                        <el-tooltip
                                          :disabled="
                                            !field.text[languageId] != ''
                                          "
                                          effect="dark"
                                          :content="field.text[languageId]"
                                          placement="right"
                                          :open-delay="800"
                                        >
                                          <el-radio
                                            v-model="
                                              storeData.formData[optionRadio.id]
                                            "
                                            :label="optionRadio.id"
                                            class="radio"
                                            :disabled="
                                              !optionRadio.slotsAvailable
                                            "
                                            @change="action(field)"
                                          >
                                            {{ optionRadio.name[languageId] }}
                                          </el-radio>
                                        </el-tooltip>
                                      </span>
                                    </el-col>
                                  </span>
                                </el-radio-group>
                              </el-form-item>
                            </span>

                            <!---------- Responsive Component: Hinweis | Type: Text ---------->
                            <span
                              v-else-if="
                                (field.type === 'Text') & !field.hideField
                              "
                            >
                              <span>
                                <p v-if="!field.hideLabel" class="text-label">
                                  <span v-html="field.name[languageId]"> </span>
                                </p>
                                <span
                                  class="text-content"
                                  v-html="field.text[languageId]"
                                ></span>
                              </span>
                              <!--/el-form-item-->
                            </span>

                            <!---------- Responsive Component: Dropdown | Type: Dropdown ---------->
                            <span
                              v-else-if="
                                (field.type === 'Dropdown') & !field.hideField
                              "
                            >
                              <el-form-item
                                :label="
                                  field.hideLabel ? false : field.name[languageId]
                                "
                                label-position="top"
                                :required="field.mandatory"
                                class="dropwdown-label"
                                :prop="field.id.toString()"
                              >
                                <el-tooltip
                                  :disabled="!field.text[languageId] != ''"
                                  effect="dark"
                                  :content="field.text[languageId]"
                                  placement="top"
                                  :open-delay="800"
                                >
                                  <el-select
                                    v-model="storeData.formData[field.id]"
                                    filterable
                                    clearable
                                    class="full-width"
                                    @change="action(field)"
                                    :value="storeData.formData[field.id]"
                                  >
                                    <el-option
                                      v-for="(
                                        optionDropdown, optionKeyDropdown
                                      ) in field.options"
                                      :key="'opti' + optionKeyDropdown"
                                      :label="optionDropdown.name[languageId]"
                                      :disabled="!optionDropdown.slotsAvailable"
                                      v-model="optionDropdown.id"
                                      :value="optionDropdown.id"
                                    >
                                    </el-option>
                                  </el-select>
                                </el-tooltip>
                              </el-form-item>
                            </span>

                            <!---------- Responsive Component: Toggle Switch | Type: ToggleSwitch ---------->
                            <span
                              v-else-if="
                                (field.type === 'ToggleSwitch') & !field.hideField
                              "
                            >
                              <el-form-item
                                :label="
                                  field.hideLabel ? false : field.name[languageId]
                                "
                                label-position="top"
                                :required="field.mandatory"
                                :prop="field.id.toString()"
                              >
                                <el-tooltip
                                  :disabled="!field.text[languageId] != ''"
                                  effect="dark"
                                  :content="field.text[languageId]"
                                  placement="bottom-start"
                                  :open-delay="800"
                                >
                                  <el-switch
                                    v-model="storeData.formData[field.id]"
                                    @change="action(field)"
                                  >
                                  </el-switch>
                                </el-tooltip>
                              </el-form-item>
                            </span>

                            <!---------- Responsive Component: AssetList | Type: AssetList ---------->
                            <span
                              v-else-if="
                                (field.type === 'AssetList') & !field.hideField
                              "
                            >
                              <el-form-item
                                :label="
                                  field.hideLabel ? false : field.name[languageId]
                                "
                                label-position="top"
                                :required="field.mandatory"
                                class="dropwdown-label"
                                :prop="field.id.toString()"
                              >
                                <el-select
                                  v-model="storeData.formData[field.id]"
                                  filterable
                                  clearable
                                  multiple
                                  collapse-tags
                                >
                                  <el-option
                                    v-for="(
                                      optionAsset, optionKeyAsset
                                    ) in field.options"
                                    :key="'opti' + optionKeyAsset"
                                    :label="optionAsset.name.intern"
                                    v-model="optionAsset.id"
                                  >
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </span>
                          </div>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </span>
              </el-form>
            </div>
          </div>
        </div>
      </div>
      <el-divider v-if="!loading && !invalidWebform"></el-divider>
      <el-row v-if="!invalidWebform" type="flex" class="button-row">
        <el-col
          v-if="
            webform.webformPageNavigation == 3 ||
            webform.webformPageNavigation == 2
          "
        >
          <el-row type="flex" align="middle" justify="start" v-show="!loading">
            <el-button
              v-bind:disabled="pageIndex === 0"
              @click="
                pageIndex -= 1;
                calculateProgressbar(pageIndex, pageIndexLast - 1);
              "
              >{{ this.buttonBack }}</el-button
            >
            <el-button
              @click="validatePageForm(pageIndex, pageIndexLast)"
              v-bind:disabled="pageIndex === pageIndexLast - 1"
              >{{ this.buttonNext }}</el-button
            >
          </el-row>
        </el-col>
        <el-col>
          <el-row type="flex" align="middle" justify="end">
            <el-button
              v-show="(showAlwaysSubmitButton && ableToSubmit) || isLastPage"
              @click="onSubmit(true)"
              class="submit-button"
              >{{ this.buttonSubmit }} </el-button
            ><!--v-bind:disabled="!(pageIndex === pageIndexLast - 1)" v-bind:disabled="!ableToSubmit"   -->
          </el-row>
        </el-col>
      </el-row>
    </div>
  </span>
</template>

<script>
export default {
  name: "Webform",
  components: {},
  watch: {
    storeData: {
      handler: function () {
        var formValid = true;

        if (typeof this.$refs["pageForm"] !== "undefined") {
          setTimeout(() => {
            this.$refs["pageForm"][0].validate();
          }, 333);
        }
        this.ableToSubmit = formValid;
      },
      deep: true,
    },
    pageIndex: {
      handler: function () {
        if (this.pageIndex + 1 === this.pageIndexLast) {
          this.isLastPage = true;
        } else {
          this.isLastPage = false;
        }
      },
    },
  },
  computed: {
    /* selectedLabel(field) {
       console.log("selectedlabel");
       console.log(field);
       console.log(this.fields);
       if (this.storeData.formData[field.id] !== null) {
         console.log(true);
         const option = field.options.find(fieldOption => fieldOption.id === this.storeData.formData[field.id]);
         console.log(option);
         return option.name[this.languageId];
 
       }
       return "";
     }, */
  },
  data: function () {
    return {
      urlParams: this.$store.getters.getUrlParams,
      startLog: null,
      formInProgress: false,
      responseHtml: "",
      noFreeOptions: [],
      showEndpageNotice: false,
      endpageNotice: "",
      invalidWebform: false,
      buttonNext: "",
      buttonBack: "",
      buttonSubmit: "",
      messageFirst: "",
      messageSecond: "",
      pageIndex: 0,
      pageIndexLast: 0,
      showAlwaysSubmitButton: false,
      progressBar: 0,
      pageFormLength: 0,
      isLastPage: false,
      languageId: this.$store.getters.getLanguageId,
      loading: true,
      loading_submit: false,
      endpoint: null,
      categories: {},
      ableToSubmit: false,
      url: process.env.VUE_APP_URL,
      webform: {},
      actions: [],
      optionFieldsIdObject: [],
      optionFieldsIdArray: [],
      optionFields: {
        userHash: null,
        formHash: null,
        optionIds: [],
      },
      storeData: {
        id: "",
        createDate: "",
        timeZoneOffset: "",
        appVersion: "1.0.0",
        appName: "Webform",
        formData: {},
        os: this.$store.getters.getOs,
        runtime: "1.0.0",
        deviceId: this.$store.getters.getDeviceId,
        captureMethod: "web",
        layoutId: 0,
        testLead: false,
        userHash: this.$store.getters.getUserHash,
        formHash: this.$store.getters.getWebformHash,
        webformLanguageId: this.$store.getters.getLanguageIdIntern,
        reCaptchaToken: "",
      },
      fields: {},
      validations: {},
    };
  },
  mounted: function () {
    this.endpoint =
      this.url + "/" + this.$store.getters.getCustomer + "/api/webApi.php";

    switch (this.languageId) {
      case "en-GB":
        this.buttonNext = "Next";
        this.buttonBack = "Previous";
        this.buttonSubmit = "Send";
        this.messageFirst = "The field ";
        this.messageSecond = " is required.";
        break;
      case "fr-FR":
        this.buttonNext = "Suivant";
        this.buttonBack = "Précédent";
        this.buttonSubmit = "S’inscrire";
        this.messageFirst = "Veuillez remplir le champ ";
        this.messageSecond = ".";
        break;
      case "de-DE":
        this.buttonNext = "Weiter";
        this.buttonBack = "Zurück";
        this.buttonSubmit = "Absenden";
        this.messageFirst = "Bitte füllen Sie das Feld ";
        this.messageSecond = " aus.";
        break;
      case "it-IT":
        this.buttonNext = "Altro";
        this.buttonBack = "Indietro";
        this.buttonSubmit = "Invia";
        this.messageFirst = "Compilare il campo ";
        this.messageSecond = " .";
        break;
      default:
        this.buttonNext = "Next";
        this.buttonBack = "Previous";
        this.buttonSubmit = "Send";
        this.messageFirst = "The field ";
        this.messageSecond = " is required.";
        break;
    }
    this.$http
      .get(this.endpoint, {
        params: {
          action: "getConfig",
          userHash: this.$store.getters.getUserHash,
          formHash: this.$store.getters.getWebformHash,
          languageId: this.$store.getters.getLanguageIdIntern,
        },
      })
      .then((response) => {
        if (process.env.NODE_ENV !== "production") {
          console.dir(response);
        }

        if (response.data.status == "OK") {
          this.pageIndexLast =
            response.data.data.form.categories[0].pages.length;
          this.categories = response.data.data.form.categories;
          this.webform = response.data.data.form.webform;
          this.actions = response.data.data.form.actions;
          this.loading = false;
          this.endpageNotice = response.data.data.form.endpageNotice;
          this.showEndpageNotice = response.data.data.form.showEndpage;
          // place the custom css
          var style = document.createElement("style");
          style.innerHTML = this.webform.webformCss;
          document.head.appendChild(style);

          if (this.webform.webformSendAnyTime) {
            this.showAlwaysSubmitButton = true;
          } else {
            this.showAlwaysSubmitButton = false;
          }

          // check wether the form is a one pager or not
          if (this.pageIndexLast === 1) {
            this.isLastPage = true;
          }

          response.data.data.form.categories.forEach((cat) => {
            cat.pages.forEach((pag) => {
              pag.rows.forEach((rowOne) => {
                rowOne.cols.forEach((colOne) => {
                  colOne.rows.forEach((rowTwo) => {
                    rowTwo.cols.forEach((colTwo) => {
                      // check if there is min. one field requiered
                      if (colTwo.field.mandatory) {
                        this.ableToSubmit = false;
                      }

                      // check if the field 'defaultValue' exists
                      var defaultValue = Object.prototype.hasOwnProperty.call(
                        colTwo.field,
                        "defaultValue"
                      );

                      this.$set(this.validations, colTwo.field.id, [
                        {
                          required: colTwo.field.mandatory,
                          message:
                            this.messageFirst +
                            colTwo.field.name[this.languageId] +
                            this.messageSecond,
                          trigger: "",
                        },
                      ]);

                      switch (colTwo.field.type) {
                        // ---------- CheckboxGroup ---------- //
                        case "CheckboxGroup":
                          // for type 'CheckboxGroup' we need to create an array because of the multi selection
                          this.$set(
                            this.storeData.formData,
                            colTwo.field.id,
                            []
                          );
                          if (colTwo.field.hasSlots) {
                            this.optionFieldsIdArray.push(colTwo.field.id);
                          }
                          // if the field is present set the value
                          if (defaultValue) {
                            this.$set(
                              this.storeData.formData,
                              colTwo.field.id,
                              parseInt(colTwo.field.defaultValue)
                            );
                          }
                          break;
                        // ---------- CheckboxGroup ---------- //
                        case "AssetList":
                          if (colTwo.field.hasSlots) {
                            this.optionFieldsIdArray.push(colTwo.field.id);
                          }
                          break;
                        // ---------- RadioGroup & Dropdown ---------- //
                        case "RadioGroup":
                        case "Dropdown":
                          if (colTwo.field.hasSlots) {
                            this.optionFieldsIdObject.push(colTwo.field.id);
                          }

                          // Sort Options
                          if (colTwo.field.sortOptionsByLanguageValue) {
                            var self = this;
                            colTwo.field.options.sort(function (a, b) {
                              let languageId = self.languageId;
                              if (!Object.hasOwn(a.name, languageId) || !Object.hasOwn(b.name, languageId)) {
                                if (Object.hasOwn(a.name, "en-GB") && Object.hasOwn(b.name, "en-GB")) {
                                  languageId = 'en-GB';
                                } else {
                                  // If language is not available fallback to internal value
                                  languageId = 'intern';
                                }
                              }

                              var nameA = a.name[languageId].toLowerCase(),
                                nameB = b.name[languageId].toLowerCase();
                              // todo: check asc or desc
                              if (nameA < nameB)
                                //sort string ascending
                                return -1;
                              if (nameA > nameB) return 1;
                              return 0; //default return value (no sorting)
                            });
                          }
                          // if the field is present set the value
                          if (defaultValue) {
                            this.$set(
                              this.storeData.formData,
                              colTwo.field.id,
                              parseInt(colTwo.field.defaultValue)
                            );
                          }
                          break;
                        // ---------- Textinput ---------- //
                        case "TextInput":
                          // check if  validation rules exists
                          var hasValidation =
                            Object.prototype.hasOwnProperty.call(
                              colTwo.field,
                              "validation"
                            );
                          // apply those rules if necessary
                          if (hasValidation) {
                            this.$set(this.validations, colTwo.field.id, [
                              {
                                required: colTwo.field.mandatory,
                                message:
                                  colTwo.field.validation.text[this.languageId],
                                pattern: atob(colTwo.field.validation.regex),
                                trigger: "",
                              },
                            ]);
                          }
                          if (this.urlParams !== null) {
                            this.urlParams.forEach((value) => {
                              var paramName = Object.keys(value)[0];
                              var paramValue = value[paramName];
                              var paramNamePrefix = paramName
                                .toString()
                                .charAt(0)
                                .toLowerCase();
                              var paramNameId = paramName
                                .toString()
                                .substring(1);
                              if (
                                paramNamePrefix == "f" &&
                                paramNameId == colTwo.field.id
                              ) {
                                this.$set(
                                  this.storeData.formData,
                                  colTwo.field.id,
                                  paramValue
                                );
                              }
                            });
                          }
                          // if the field is present set the value
                          if (defaultValue) {
                            this.$set(
                              this.storeData.formData,
                              colTwo.field.id,
                              colTwo.field.defaultValue
                            );
                          }
                          break;
                        // falls through
                        default:
                          this.$set(this.validations, colTwo.field.id, [
                            {
                              required: colTwo.field.mandatory,
                              message:
                                this.messageFirst +
                                colTwo.field.name[this.languageId] +
                                this.messageSecond,
                              trigger: "",
                            },
                          ]);
                          // if the field is present set the value
                          if (defaultValue) {
                            this.$set(
                              this.storeData.formData,
                              colTwo.field.id,
                              colTwo.field.defaultValue
                            );
                          }
                      }
                    });
                  });
                });
              });
            });
          });

          setTimeout(() => {
            this.$refs["pageForm"][0].validate();
          }, 333);
        } else {
          this.responseHtml = response.data.data;
          this.invalidWebform = true;
          this.loading = false;
        }
      })
      .catch((error) => {
        console.log(error);
        /*this.$http
              .post(
                  "https://entergonde.webhook.office.com/webhookb2/dcef73c6-fbe1-4df7-b3b4-1dbf2f615e39@e03b9d8e-4622-4e21-991b-fc827c33083c/IncomingWebhook/8121d5b0a008410ebb4ed2b9cb21231c/3fcae70d-0acc-4d88-93f8-d8143f1497f5",
                  error,
                  {headers: {Accept: "application/json"}}
              )*/
      });

    /**
     * include recaptcha script

     let recaptchaScript = document.createElement("script");
     recaptchaScript.setAttribute(
     "src",
     "https://www.google.com/recaptcha/api.js"
     );
     document.head.appendChild(recaptchaScript);*/
  },
  methods: {
    validatePageForm(pageIndex, pageIndexLast) {
      this.$refs["pageForm"][pageIndex].validate((valid) => {
        if (valid) {
          this.pageIndex += 1;
          this.calculateProgressbar(this.pageIndex, pageIndexLast - 1);
        } else {
          this.openFieldRequiredDialog();
          return false;
        }
      });
    },
    /**
     *  check if there is a form action
     */
    action(field, optionsId) {
      // check if field it is in array
      var fieldId = field.id;
      var fieldType = field.type;
      var fieldValue = '';
      this.actions.forEach((obj) => {
        var targetFieldId = obj.action.fieldId;
        var optionId = "none";

        if (fieldType == "RadioGroup" || fieldType === "Dropdown") {
          optionId = this.storeData.formData[fieldId];
          var isSingleOption = true;
        }

        if (
          ((fieldType == "CheckboxGroup" || fieldType == "AssetList") &&
            obj.condition.fieldId == fieldId &&
            obj.condition.selectedOptionId == optionsId) || // Condition: Specific option selected (MultiSelection)
          (isSingleOption &&
            obj.condition.fieldId == fieldId &&
            obj.condition.selectedOptionId == optionId) || // Condition: Specific option selected (SingleSelection)
          (obj.condition.type == "hasValue" && obj.condition.fieldId == fieldId)
        ) {
          // Condition:  Not empty
          this.categories.forEach((cat) => {
            cat.pages.forEach((pag) => {
              pag.rows.forEach((rowOne) => {
                rowOne.cols.forEach((colOne) => {
                  colOne.rows.forEach((rowTwo) => {
                    rowTwo.cols.forEach((colTwo) => {
                      if (colTwo.field.id == targetFieldId) {
                        switch (obj.action.type) {
                          case "hideField":
                              colTwo.field.hideField = true;
                            break;
                          case "showField":
                              colTwo.field.hideField = false;
                            break;
                          case "setFieldOptional":
                            colTwo.field.mandatory = false;
                            this.$set(this.validations, colTwo.field.id, []);
                            break;
                          case "setFieldRequired":
                            colTwo.field.mandatory = true;
                            this.$set(this.validations, colTwo.field.id, [
                              {
                                required: colTwo.field.mandatory,
                                message:
                                  this.messageFirst +
                                  colTwo.field.name[this.languageId] +
                                  this.messageSecond,
                                trigger: "",
                              },
                            ]);
                            break;
                          case "selectOption":
                            if (
                              obj.action.selectOptionId === null &&
                              this.storeData.formData[colTwo.field.id] != null
                            ) {
                              this.storeData.formData[colTwo.field.id] = "";
                            }
                            break;
                          case "resetField":
                            if(typeof colTwo.field.defaultValue !== 'undefined') {
                              if ((colTwo.field.defaultValue).length != 0) {
                                fieldValue = colTwo.field.defaultValue
                              }
                            } else {
                              fieldValue = ''
                            }
                            this.$set(this.storeData.formData, targetFieldId, fieldValue);
                            break;
                          case "deactivateField":
                            field = colTwo.field
                            field.disabled = true;
                            field.class = field.class || [];
                            if (!field.class.includes("is-disabled")) {
                              field.class.push("is-disabled");
                            }
                            break;
                          case "activateField":
                            field = colTwo.field
                            field.disabled = false;
                            field.class = field.class || [];
                            field.class = field.class.filter(c => c !== "is-disabled");
                            break;
                        }
                      }
                    });
                  });
                });
              });
            });
          });
        }
      });
    },
    /**
     * submit the form to the entergon server
     */
    async onSubmit() {
      if (!this.formInProgress) {
        this.formInProgress = true;

        // if google reCaptcha is active we get the token for the request
        if (this.webform.webformRecaptcha) {
          await this.$recaptchaLoaded();
          this.storeData.reCaptchaToken = await this.$recaptcha("form");

          const startReCaptcha = Date.now();
          this.$http
            .post(this.endpoint, this.storeData, {
              params: { action: "checkReCaptchaAction" },
              headers: { "Content-Type": "application/json" },
            })
            .then(async (response) => {
              if (response.data.status == "OK") {
                const endReCaptcha = Date.now();
                console.log(
                  "Recaptcha: ",
                  (endReCaptcha - startReCaptcha) / 1000
                );
                // score is okay - no robot
                await this.storeLeadData();
              } else {
                // robot from google detected
                this.openGoogleReCaptchaDialog();
              }
            })
            .catch(function () {
              // something went wrong
              this.openGoogleReCaptchaDialog();
              this.formInProgress = false;
            });
        } else {
          // reCaptcha not active - proceed without check
          await this.storeLeadData();
        }
      }
    },
    /**
     *
     * @returns {Promise<boolean>}
     */
    async storeLeadData() {
      var formValid = true;

      this.startLog = Date.now();

      // check if the form is valid
      for (var i = 0; i < this.$refs["pageForm"].length; i++) {
        this.$refs["pageForm"][i].validate((e) => {
          if (!e) {
            formValid = false;
          }
        });
      }

      if (formValid) {
        // getting some general information for the request
        var date = new Date();
        this.storeData.createDate = date.toISOString();
        this.storeData.timeZoneOffset = date.getTimezoneOffset();
        this.optionFields.formHash = this.$store.getters.getWebformHash;
        this.optionFields.userHash = this.$store.getters.getUserHash;

        // get all option id's from single selection field types
        this.optionFieldsIdObject.forEach((fieldId) => {
          if (
            Object.prototype.hasOwnProperty.call(
              this.storeData.formData,
              fieldId
            )
          ) {
            this.optionFields.optionIds.push(this.storeData.formData[fieldId]);
          }
        });
        // get all option id's from multi selection field types
        this.optionFieldsIdArray.forEach((fieldId) => {
          if (
            Object.prototype.hasOwnProperty.call(
              this.storeData.formData,
              fieldId
            )
          ) {
            this.storeData.formData[fieldId].forEach((optionFieldId) => {
              if (optionFieldId) {
                if (
                  typeof optionFieldId === "string" ||
                  optionFieldId instanceof String
                ) {
                  this.optionFields.optionIds.push(parseInt(optionFieldId));
                } else {
                  this.optionFields.optionIds.push(optionFieldId);
                }
              }
            });
          }
        });
        // if options are set - check if they are still available
        if (this.optionFields.optionIds.length > 0) {
          const startSlotCheck = Date.now();
          this.$http
            .post(this.endpoint, this.optionFields, {
              params: {
                action: "checkFreeRegistrationSlot",
                userHash: this.$store.getters.getUserHash,
                formHash: this.$store.getters.getWebformHash,
                languageId: this.$store.getters.getLanguageIdIntern,
              },
              headers: { "Content-Type": "application/json" },
            })
            .then((response) => {
              var self = this;
              // all selected options were available -proceed with storing the lead
              if (response.data.status == "OK") {
                const endSlotCheck = Date.now();
                console.log(
                  "Slot Check: ",
                  (endSlotCheck - startSlotCheck) / 1000
                );
                this.optionFields.optionIds = [];
                this.storeData.id = this.$sha("sha256")
                  .update(this.storeData.deviceId + Date.now())
                  .digest("hex");
                const startSlotLeadAfterStoreCheck = Date.now();
                this.$http
                  .post(this.endpoint, this.storeData, {
                    params: { action: "storeLeadData" },
                    headers: { "Content-Type": "application/json" },
                  })
                  .then(function (response) {
                    if (response.data.status == "OK") {
                      const endSlotLeadAfterStoreCheck = Date.now();
                      console.log(
                        "Store Lead after Slot Check: ",
                        (endSlotLeadAfterStoreCheck -
                          startSlotLeadAfterStoreCheck) /
                          1000
                      );
                      if (self.showEndpageNotice) {
                        self.responseHtml = self.endpageNotice[self.languageId];
                        self.invalidWebform = true;
                        self.loading = false;
                      }
                      self.openSuccessDialog();

                      // resetting the form
                      for (var i = 0; i < self.$refs["pageForm"].length; i++) {
                        self.$refs["pageForm"][i].resetFields();
                      }
                      self.pageIndex = 0;
                      self.formInProgress = false;
                      // there was an error while storing the lead
                    } else if (response.data.status === "NOK") {
                      self.openErrorDialog();
                      self.formInProgress = false;
                    }
                  })
                  // an error occured
                  .catch(function (error) {
                    self.openErrorDialog();
                    console.log(error);
                    self.formInProgress = false;
                  });
                // one or more selected options were not available anymore
              } else {
                const startSlotCheckNok = Date.now();
                this.optionFields.optionIds = [];
                response.data.data.options.forEach((option) => {
                  self.noFreeOptions.push(parseInt(option));
                });
                self.categories.forEach((cat) => {
                  cat.pages.forEach((pag) => {
                    pag.rows.forEach((rowOne) => {
                      rowOne.cols.forEach((colOne) => {
                        colOne.rows.forEach((rowTwo) => {
                          rowTwo.cols.forEach((colTwo) => {
                            if (
                              Object.prototype.hasOwnProperty.call(
                                colTwo.field,
                                "options"
                              )
                            ) {
                              colTwo.field.options.forEach((fieldOption) => {
                                self.noFreeOptions.forEach((option) => {
                                  if (option === fieldOption.id) {
                                    fieldOption.slotsAvailable = false;
                                  }
                                });
                              });
                            }
                          });
                        });
                      });
                    });
                  });
                });
                // todo: reset only the option fields
                for (var i = 0; i < self.$refs["pageForm"].length; i++) {
                  self.$refs["pageForm"][i].resetFields();
                }

                self.pageIndex = 0;
                self.openSlotDialog();
                self.formInProgress = false;
                const endSlotCheckNok = Date.now();
                console.log(
                  "Slot Check NOK: ",
                  (endSlotCheckNok - startSlotCheckNok) / 1000
                );
              }
            });
        } else {
          var self = this;
          this.storeData.id = this.$sha("sha256")
            .update(this.storeData.deviceId + Date.now())
            .digest("hex");
          const startStoreLead = Date.now();
          this.$http
            .post(this.endpoint, this.storeData, {
              params: { action: "storeLeadData" },
              headers: { "Content-Type": "application/json" },
            })
            .then(function (response) {
              if (response.data.status == "OK") {
                const endStoreLead = Date.now();
                console.log(
                  "Store Lead: ",
                  (endStoreLead - startStoreLead) / 1000
                );
                if (self.showEndpageNotice) {
                  self.responseHtml = self.endpageNotice[self.languageId];
                  self.invalidWebform = true;
                  self.loading = false;
                }
                self.openSuccessDialog();

                for (var i = 0; i < self.$refs["pageForm"].length; i++) {
                  self.$refs["pageForm"][i].resetFields();
                }
                self.pageIndex = 0;
              } else if (response.data.status === "NOK") {
                self.openErrorDialog();
                console.log(response);
                this.formInProgress = false;
              }
            })
            .catch(function (error) {
              self.openErrorDialog();
              console.error(error);
              self.formInProgress = false;
            });
        }
        const endLog = Date.now();
        console.log("End: ", (endLog - this.startLog) / 1000);
      } else {
        this.openFieldRequiredDialog();
        this.formInProgress = false;
      }
    },
    /**
     * genereted hash with will be our id
     *
     * @param val Value
     */
    async sha256(val) {
      this.$sha("sha256").update(val);

      /*const buf = await crypto.subtle.digest(
          "SHA-256",
          new TextEncoder("utf-8").encode(timestamp, devideId)
      );
      return Array.prototype.map
          .call(new Uint8Array(buf), (x) => ("00" + x.toString(16)).slice(-2))
          .join("");*/
    },
    /**
     * reset form fields
     * @param form
     * @return
     */
    resetForm(formData) {
      this.$refs[formData].resetFields();
    },
    getWebformWidth(){
      return window.innerWidth;
    },
    openSuccessDialog() {
      var msg;
      switch (this.languageId) {
        case "de-DE":
          msg = "Ihre Anfrage war erfolgreich.";
          break;
        case "en-GB":
          msg = "Your request was successful.";
          break;
        case "fr-FR":
          msg = "Votre demande a été acceptée.";
          break;
        default:
          msg = "Ihre Anfrage war erfolgreich.";
      }
      this.$message({
        message: msg,
        type: "success",
      });
    },
    openFieldRequiredDialog() {
      var msg;
      switch (this.languageId) {
        case "de-DE":
          msg = "Bitte füllen Sie alle erforderlichen Felder aus.";
          break;
        case "en-GB":
          msg = "Please provide all required field.";
          break;
        case "fr-FR":
          msg = "Veuillez remplir tous les champs obligatoires.";
          break;
        default:
          msg = "Bitte füllen Sie alle erforderlichen Felder aus.";
      }
      this.$message({
        message: msg,
      });
    },
    openGoogleReCaptchaDialog() {
      var msg;
      switch (this.languageId) {
        case "de-DE":
          msg = "Google reCaptcha war nicht erfolgreich.";
          break;
        case "en-GB":
          msg = "Google reCaptcha was not successful.";
          break;
        case "fr-FR":
          msg = "Google reCaptcha n'a pas réussi.";
          break;
        default:
          msg = "Google reCaptcha war nicht erfolgreich.";
      }
      this.$message({
        message: msg,
      });
    },
    openErrorDialog() {
      var msg;
      switch (this.languageId) {
        case "de-DE":
          msg =
            "Ein Fehler ist aufgetreten. Bitte kontaktieren Sie den Administrator der Seite.";
          break;
        case "en-GB":
          msg =
            "An error occured. Please contact the administrator of the site.";
          break;
        case "fr-FR":
          msg =
            "Une erreur s'est produite. Veuillez contacter l'administrateur du site.";
          break;
        default:
          msg =
            "Ein Fehler ist aufgetreten. Bitte kontaktieren Sie den Administrator der Seite.";
      }
      this.$message({
        message: msg,
        type: "error",
      });
    },
    /**
     *
     */
    openSlotDialog() {
      var msg;
      switch (this.languageId) {
        case "de-DE":
          msg = "Eine oder mehrere Optionen stehen nicht mehr zur Auswahl.";
          break;
        case "en-GB":
          msg = "One or more options are no longer available for selection.";
          break;
        case "fr-FR":
          msg =
            "Une ou plusieurs options ne sont plus disponibles pour la sélection.";
          break;
        default:
          msg = "Eine oder mehrere Optionen stehen nicht mehr zur Auswahl.";
      }
      this.$message({
        message: msg,
        type: "error",
      });
    },
    /**
     * calculate the progression for the
     * @param currentPage current page
     * @param maxPages count of all pages
     *
     */
    calculateProgressbar(currentPage, maxPages) {
      this.progressBar = Math.trunc((currentPage / maxPages) * 100);
    },
  },
};
</script>

<style>
.el-message {
  min-width: 220px !important;
}

.divider-line {
  display: block;
  height: 1px;
  width: 100%;
  margin: 24px 0 30px;
  background-color: #dcdfe6;
  position: relative;
}

.divider-left {
  left: 20px;
  transform: translateY(-50%);
  position: absolute;
  background-color: #fff;
  padding: 0 20px;
  color: #303133;
  font-weight: 500;
  font-size: 14px;
}

.divider-right {
  right: 20px;
  transform: translateY(-50%);
  position: absolute;
  background-color: #fff;
  padding: 0 20px;
  color: #303133;
}

.el-progress-bar {
  margin-right: -40px !important;
}

.el-progress {
  margin-bottom: 10px;
}

.button-row {
  margin-top: 20px;
  padding: 0 10px 10px;
}

.page-title {
  font-size: larger;
}

.radio {
  margin-bottom: 10px;
}

.radio-label .el-form-item__label {
  float: none;
}

.date-picker-label .el-form-item__label {
  float: none;
}

.dropwdown-label .el-form-item__label {
  float: none;
}

.checkbox-label .el-form-item__label {
  float: none;
}

.checkbox-col {
  line-height: 23px;
}

.el-checkbox__label {
  white-space: normal;
}

.el-checkbox__input {
  vertical-align: top;
}

.text-label {
  text-align: left;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  margin: 0;
}

.text-content {
  text-align: justify;
  vertical-align: middle;
  color: #606266;
  line-height: 20px;
  margin: 0;
}

.full-width {
  width: 100%;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100% !important;
}

/*@media (max-width: 380px) {
  .el-select-dropdown__list {
    text-align: right;
  }
}*/

.required label::after {
  content: "" !important;
}
</style>
